module.exports = __webpack_public_path__ + "img/menu-change-personal.236eac99.svg";